import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/* Honors the organization's default dispatch view; `?classic=1` always forces the legacy board. */
export default function WarRoomRedirect({ children }) {
  const { org } = useAuth();
  const [params] = useSearchParams();
  if (org?.dispatch_default_view === "war_room" && params.get("classic") !== "1") return <Navigate to="/war-room" replace />;
  return children;
}
